import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../CSS/profile.css";
import { updatePassword } from "../../api/accounts";
import Swal from "sweetalert2";
import updatePassImg from "../assets/update-password.webp";
import smartKey from "../assets/smart-key.webp";

export default function EditPassword() {
  return (
    <div className="profile-main">
      <div className="update-password-img-container">
        <img className="update-password-img" src={updatePassImg} />
      </div>
      <div className="update-password-form">
        <h3> <img className="inner-buttons-icons" src={smartKey} />Update your password</h3>
      <hr /> 
      <Formik
        initialValues={{
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        validationSchema={Yup.object({
          oldPassword: Yup.string().required("Old password is required"),
          newPassword: Yup.string()
            .min(6, "New password must be at least 6 digit long")
            .matches(
              /^(?=.*[a-z])(?=.*[0-9])/,
              "Invalid password format - must have atleast one lower case and a digit."
            )
            .required("New password is required"),
          confirmPassword: Yup.string().when("newPassword", {
            is: (val) => (val && val.length > 0 ? true : false),
            then: Yup.string().oneOf(
              [Yup.ref("newPassword")],
              "Both password need to be the same."
            ),
          }),
        })}
        onSubmit={(values, { setSubmitting }) => {
          const swal = Swal.mixin({});
          updatePassword(values.oldPassword, values.newPassword)
            .then(() => {
              Swal.fire({ title: "Password updated!", icon: "success", showConfirmButton: false, timer: 2500 });
            })
            .catch((error): any => {
              Swal.fire({
                title: "Password not updated!",
                text: "Make sure your old password is correct.",
                icon: "error",
                timer: 2500
              });
            });
          setSubmitting(false);
        }}
      >
        {({ touched, errors, values, isSubmitting }) => (
          <Form>
            <div className="form-group">
              <label htmlFor="oldPassword">Enter your old password:</label>
              <Field
                type="password"
                name="oldPassword"
                placeholder="Current password"
                className={`form-control ${
                  touched.oldPassword && errors.oldPassword ? "is-invalid" : ""
                } ${
                  errors.oldPassword || values.oldPassword === ""
                    ? ""
                    : "is-valid"
                }`}
              />
              <ErrorMessage
                component="div"
                name="oldPassword"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <label htmlFor="newPassword">Enter your new password:</label>
              <Field
                type="password"
                name="newPassword"
                placeholder="New password"
                className={`form-control ${
                  touched.newPassword && errors.newPassword ? "is-invalid" : ""
                } ${
                  errors.newPassword || values.newPassword === ""
                    ? ""
                    : "is-valid"
                }`}
              />
              <ErrorMessage
                component="div"
                name="newPassword"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirmPassword">
                Re-enter your new password:
              </label>
              <Field
                type="password"
                name="confirmPassword"
                placeholder="Confirm password"
                className={`form-control ${
                  touched.confirmPassword && errors.confirmPassword
                    ? "is-invalid"
                    : ""
                } ${
                  errors.confirmPassword || values.confirmPassword === ""
                    ? ""
                    : "is-valid"
                }`}
              />
              <ErrorMessage
                component="div"
                name="confirmPassword"
                className="invalid-feedback"
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              Update password
            </button>
          </Form>
        )}
      </Formik>
      </div>
    </div>
  );
}
